import post from '@app-src/data/api/post-to-api'
import { PriceDropPayloadType } from './types'

/**
 * subscribeToPriceDrop
 * @description subscribes to a price drop alert
 * takes an object with these members:
 * @param {Object} payload - the subscribe to price drop payload
 */
const subscribeToPriceDrop = async ({
  payload,
  ...extraMiddleware
}: {
  payload: PriceDropPayloadType
}): Promise<Response> =>
  post({
    fetchContext: 'Subscribe to price drops',
    ...extraMiddleware
  })('inventory/api', 'v1/inventory-price/subscribe-price-drop-alert', payload)

export default subscribeToPriceDrop
